import React from 'react';
import Divider from '@material-ui/core/Divider';

const CDivider = () => {
    return <Divider />
}

export default CDivider